import React from "react";
import { Card, Image } from "semantic-ui-react";
import { Field } from "formik";
import { Checkbox } from "components/Form/SpecialButtons";

const styles = {
	cardContent: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		flexWrap: "wrap",
	},
	cardSelect: {
		margin: "auto",
		":hover": { backgroundColor: "rgba(0,0,0,0.1)" },
	},
	tubeImage: {
		marginBottom: "1em",
	},
	cardHeader: {
		width: "100%",
		textAlign: "center",
	},
};

const TubesForm = ({ tubesSelected }) => (
	<div>
		{tubesSelected &&
			tubesSelected.map((element) => (
				<Card key={`tube-${element.id}`} style={styles.cardSelect}>
					<Card.Content style={styles.cardContent}>
						{element.picto && (
							<Image style={styles.tubeImage} size="tiny" src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${element.picto.filename}`} />
						)}
						{!element.picto && (
							<Image
								style={styles.tubeImage}
								size="tiny"
								src={`${process.env.REACT_APP_BASE_URL}/tubePictos/${process.env.REACT_APP_TUBE_PIC_FILENAME}`}
							/>
						)}
						<Card.Header style={styles.cardHeader}>{element.code}</Card.Header>
						<Card.Meta>{element.label}</Card.Meta>
						{element.aliquot && (
							<Card.Meta>
								<Field
									customlabel="Aliquot pour centres spécifiques"
									component={Checkbox}
									name={`tube_specific_${element.id}`}
									id={`tube_specific_${element.id}`}
								/>{" "}
							</Card.Meta>
						)}
					</Card.Content>
				</Card>
			))}
		{(!tubesSelected || tubesSelected.length === 0) && <div style={styles.cardHeader}>Aucun tube associé</div>}
	</div>
);

export default TubesForm;
